/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ln_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A longer term lowers each monthly payment because the principal is spread over more months, but interest is charged on the outstanding balance every one of those months, so you pay it for longer. The result is a smaller monthly payment yet a larger total interest over the life of the loan.`)
};

const es_ln_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un plazo más largo reduce cada pago mensual porque el principal se distribuye en más meses, pero se cobra interés sobre el saldo pendiente cada uno de esos meses, por lo que lo paga durante más tiempo. El resultado es un pago mensual más pequeño pero un interés total más grande durante la vida del préstamo.`)
};

const de_ln_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine längere Laufzeit senkt jede monatliche Rate, da die Tilgungssumme auf mehr Monate verteilt wird. Zinsen fallen jedoch in jedem dieser Monate auf die Restschuld an, sodass Sie sie über einen längeren Zeitraum zahlen. Das Ergebnis ist eine niedrigere monatliche Rate, aber insgesamt höhere Zinsen über die gesamte Laufzeit des Darlehens.`)
};

const nl_ln_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een langere looptijd verlaagt elke maandelijkse betaling omdat het kapitaal over meer maanden wordt verdeeld, maar rente wordt berekend op het openstaande saldo elke maand van die maanden, dus u betaalt het langer. Het resultaat is een kleinere maandelijkse betaling maar een grotere totale rente over de levensduur van de lening.`)
};

const fr_ln_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une durée plus longue réduit chaque paiement mensuel car le principal est réparti sur plus de mois, mais les intérêts sont facturés sur le solde impayé chacun de ces mois, donc vous le payez plus longtemps. Le résultat est un paiement mensuel plus faible mais un intérêt total plus important sur la durée du prêt.`)
};

const it_ln_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un termine più lungo riduce ogni pagamento mensile perché il capitale è distribuito su più mesi, ma gli interessi vengono addebitati sul saldo residuo ogni uno di quei mesi, quindi lo paghi più a lungo. Il risultato è un pagamento mensile più piccolo ma un interesse totale più grande nel corso della vita del prestito.`)
};

const pt_br2_ln_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um prazo mais longo reduz cada pagamento mensal porque o principal é distribuído ao longo de mais meses, mas juros são cobrados sobre o saldo devedor a cada um desses meses, portanto você o paga por mais tempo. O resultado é um pagamento mensal menor, mas um total de juros maior durante a vida do empréstimo.`)
};

const pt_ln_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um prazo mais longo reduz cada pagamento mensal porque o capital é distribuído durante mais meses, mas os juros são cobrados sobre o saldo pendente em cada um desses meses, pelo que paga durante mais tempo. O resultado é um pagamento mensal mais pequeno, mas um total de juros maior ao longo da vida do empréstimo.`)
};

const ja_ln_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「長期間は月々支払額を低くします。これは元本がより多くの月数に分散しているためですが、利息は毎月未払い残高に請求されるため、より長くお支払いになります。その結果、月々支払額は小さくなりますが、ローンの生涯にわたって合計利息はより大きくなります。」`)
};

const zh_ln_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`期限越长，本金分摊到的月数越多，每月还款额就越低；但每个月都会对未偿余额计息，计息时间也就更长。结果是月供减少，但贷款整个期限内的利息总额增加。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ln_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ln_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ln_faq4_a", locale)
	if (locale === "en") return en_ln_faq4_a(inputs)
	if (locale === "es") return es_ln_faq4_a(inputs)
	if (locale === "de") return de_ln_faq4_a(inputs)
	if (locale === "nl") return nl_ln_faq4_a(inputs)
	if (locale === "fr") return fr_ln_faq4_a(inputs)
	if (locale === "it") return it_ln_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_ln_faq4_a(inputs)
	if (locale === "pt") return pt_ln_faq4_a(inputs)
	if (locale === "ja") return ja_ln_faq4_a(inputs)
	return zh_ln_faq4_a(inputs)
};